import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  title: string;
  message: string;
  buttonText: string;
  submit: Function;
  cancel: Function;
  hideCancel: boolean;

  constructor(public bsModalRef: BsModalRef) {
    this.buttonText = 'CONFIRM';
  }

  ngOnInit() { }

  onCancel() {
    // Feedback if confirm is cancelled
    if (!!this.cancel) {
      this.cancel();
    }
    this.bsModalRef.hide();
  }

  onSubmit() {
    // Call on submit
    this.submit();
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/confirm-dialog/confirm-dialog.component.ts